<template>
  <div class="m-b-20">
    <div class="row">
      <div class="col-sm-5">
        <h4>{{ insurance.title }} Insurance</h4>
        <WdsRadioGroup v-model:checked="form.has_insurance" :name="`has_${insurance.key}`">
          <WdsRadio :name="`has_${insurance.key}`" :value="false">
            I do not have {{ insurance.title }} insurance
            <i class="input-helper"></i>
          </WdsRadio>
          <WdsRadio :name="`has_${insurance.key}`" :value="true">
            I have {{ insurance.title }} insurance
            <i class="input-helper"></i>
          </WdsRadio>
        </WdsRadioGroup>
      </div>
      <div class="col-sm-7">
        <template v-if="insurance?.has_account_no || false">
          <div v-if="form.has_insurance" class="bgm-white p-20 m-b-20 rounded">
            <p class="c-black">
              If you have {{ insurance.title }} insurance, please enter your
              <strong>Account Number</strong>
              .
              <br />
            </p>
            <label>Workers Compensation Account Number</label>
            <br />
            <input
              v-model="form.insurance_account_no"
              type="text"
              :name="`${insurance.key}_insurance_account_no`"
              class="form-control"
              placeholder="Enter account no."
            />
          </div>
        </template>

        <template v-if="insurance?.has_policy_details || false">
          <div v-if="form.has_insurance" class="bgm-white p-20 m-b-20 rounded">
            <p class="c-black">
              If you have {{ insurance.title }} insurance, please list your
              <strong>policy limit</strong>
              and
              <strong>upload</strong>
              the policy certificate as proof.
              <br />
              <span class="small c-gray">
                Without proof we will regard you as not having insurance.
              </span>
            </p>
            <div class="row">
              <div class="col-sm-6">
                <label>Policy limit</label>
                <br />
                <div class="input-group">
                  <span class="input-group-addon">$</span>
                  <input
                    v-model.number="form.insurance_policy_limit"
                    type="number"
                    :name="`${insurance.key}_policy_limit`"
                    class="form-control text-right"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <label>File(s)</label>
                <br />
                <PickerFileFilebank
                  class=""
                  :pre-selected-files="form?.proof_of_insurance_file_ids || []"
                  :use-input-field="true"
                  :input-name="`${insurance.key}_file_ids[]`"
                  :default-tags="[$t('Insurance proof')]"
                />
              </div>
            </div>
            <p class="m-t-20 m-b-0 small">
              By uploading a document here, I confirm that the attached files demonstrate legal
              proof of insurance.
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { WdsRadio, WdsRadioGroup } from '@worksome/wds-components'
import PickerFileFilebank from '@/components/PickerFileFilebank.vue'

export default {
  name: 'UsWorkerClassificationInsuranceProofFormSection',
  components: {
    WdsRadio,
    WdsRadioGroup,
    PickerFileFilebank,
  },
  props: {
    insurance: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.formData,
    }
  },
}
</script>
